// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c167e6cf","488":"d90575e3","977":"6fef74f6"}[chunkId] + ".chunk.js";
};